/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_stx_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Race Results ranks drivers and constructors by real-world performance — total championship points, average qualifying position, and average finish. Fantasy Stats ranks the same field by F1 Fantasy scoring. Compare the two to find drivers whose real-world pace converts efficiently into fantasy points.`)
};

const es_f1_stx_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultados de Carrera clasifica a pilotos y constructores por rendimiento real — puntos totales del campeonato, posición media de clasificación y llegada media. Fantasy Stats clasifica al mismo grupo por puntuación de F1 Fantasy. Compara ambas para encontrar pilotos cuyo ritmo real se convierte eficientemente en puntos fantasy.`)
};

const de_f1_stx_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rennergebnisse ordnet Fahrer und Konstrukteure nach realer Leistung — Gesamtmeisterschaftspunkte, durchschnittliche Qualifying-Position und durchschnittlicher Zieleinlauf. Fantasy-Statistiken ordnet dasselbe Feld nach F1-Fantasy-Wertung. Vergleiche beide, um Fahrer zu finden, deren reales Tempo effizient in Fantasy-Punkte umgesetzt wird.`)
};

const nl_f1_stx_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raceresultaten rangschikt coureurs en constructeurs op prestaties uit de echte wereld — totale kampioenschapspunten, gemiddelde kwalificatiepositie en gemiddelde finish. Fantasy Stats rangschikt hetzelfde veld op F1 Fantasy-scoring. Vergelijk de twee om coureurs te vinden wiens tempo in de echte wereld efficiënt wordt omgezet in fantasy-punten.`)
};

const fr_f1_stx_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résultats de Course classe les pilotes et constructeurs par performance réelle — points totaux au championnat, position moyenne en qualification et arrivée moyenne. Fantasy Stats classe le même ensemble par notation F1 Fantasy. Comparez les deux pour trouver des pilotes dont le rythme réel se convertit efficacement en points fantasy.`)
};

const it_f1_stx_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risultati Gara classifica piloti e costruttori in base al rendimento reale — punti totali di campionato, posizione media in qualifica e arrivo medio. Fantasy Stats classifica lo stesso campo in base al punteggio F1 Fantasy. Confronta i due per trovare piloti il cui ritmo reale si converte efficacemente in punti fantasy.`)
};

const pt_br2_f1_stx_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultados de Corrida classifica pilotos e construtores por desempenho real — pontos totais do campeonato, posição média de classificação e chegada média. Fantasy Stats classifica o mesmo grupo pela pontuação de F1 Fantasy. Compare os dois para encontrar pilotos cujo ritmo real se converte de forma eficiente em pontos fantasy.`)
};

const pt_f1_stx_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultados de Corrida classifica pilotos e construtores por desempenho real — pontos totais do campeonato, posição média de qualificação e chegada média. Fantasy Stats classifica o mesmo conjunto por pontuação de F1 Fantasy. Compare os dois para encontrar pilotos cujo ritmo real se converte eficazmente em pontos fantasy.`)
};

const ja_f1_stx_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レース結果は、実際のパフォーマンス——合計選手権ポイント、平均予選順位、平均フィニッシュ——でドライバーとコンストラクターをランク付けします。Fantasy Statsは同じ対象をF1ファンタジーのスコアリングでランク付けします。両方を比較することで、実際のペースが効率的にファンタジーポイントに変換されているドライバーを見つけられます。`)
};

const zh_f1_stx_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比赛结果按真实表现——锦标赛总积分、平均排位成绩和平均完赛名次——为车手和车队排名。梦幻统计则按F1梦幻计分方式对同一批车手和车队排名。对比两者,可以找到那些真实赛场速度能高效转化为梦幻积分的车手。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_stx_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_stx_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_stx_faq1_a", locale)
	if (locale === "en") return en_f1_stx_faq1_a(inputs)
	if (locale === "es") return es_f1_stx_faq1_a(inputs)
	if (locale === "de") return de_f1_stx_faq1_a(inputs)
	if (locale === "nl") return nl_f1_stx_faq1_a(inputs)
	if (locale === "fr") return fr_f1_stx_faq1_a(inputs)
	if (locale === "it") return it_f1_stx_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_f1_stx_faq1_a(inputs)
	if (locale === "pt") return pt_f1_stx_faq1_a(inputs)
	if (locale === "ja") return ja_f1_stx_faq1_a(inputs)
	return zh_f1_stx_faq1_a(inputs)
};